import { basket } from '../../types';
import bossApi from '../../utils/fetch-api';

const DEFAULT_OPTIONS = { m2m: true, authScope: process.env.BOSS_API_AUTH_SCOPE_BASKET };

/**
 * Fetch basket by basket id
 */
export const getBasketById = (basketId: string, locale: string) => {
  return bossApi<basket.Basket>(`/basket/v2/baskets/${basketId}`, {
    ...DEFAULT_OPTIONS,
    locale,
  });
};

/**
 * Force a basket recalculation on the backend and return the refreshed basket.
 *
 * Sends a PUT with the minimal `pricesummary.recalculateneeded=true` body so the
 * backend recomputes prices/discounts before responding. The happy path is a
 * single PUT — no preceding GET — so the checkout/payment chain stays short
 * (see 45136: a GET+PUT pair here contributed to the 30s function timeout).
 *
 * When the PUT is rejected (the backend refuses mutations while it is already
 * recalculating, e.g. 409 on PriceSummary.RecalculateNeeded), fall back to the
 * current snapshot instead of hard-blocking checkout (see 45613/45615). The
 * amount comparison downstream still guards a stale snapshot. No full-snapshot
 * PUT is ever sent, so the 409-storm mechanism from 44753 is not reintroduced.
 */
export const recalculateBasket = async (basketId: string, locale: string) => {
  try {
    return await bossApi<basket.Basket>(`/basket/v2/baskets/${basketId}`, {
      ...DEFAULT_OPTIONS,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: { pricesummary: { recalculateneeded: true } } as unknown as Record<string, unknown>,
      locale,
    });
  } catch {
    return getBasketById(basketId, locale);
  }
};
